import {
  ArrowRight,
  Bot,
  Check,
  ChevronRight,
  FileUp,
  Sparkles,
} from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../components/ui/Button'
import { StatusLabel } from '../../components/ui/StatusLabel'
import { KNOWLEDGE_MODULES, LEARNING_TASKS } from '../../data/dashboardData'
import { useAppState } from '../../state/AppState'

export function TodayPage() {
  const navigate = useNavigate()
  const { completedTaskIds, toggleTask } = useAppState()

  return (
    <div className="today-page">
      <section className="welcome-block" aria-labelledby="today-heading">
        <div>
          <h1 id="today-heading">开始今天的数学学习</h1>
          <p>先完成入学诊断，系统将生成第一版高一数学学习路径。</p>
        </div>
        <Button
          size="large"
          leadingIcon={<Sparkles size={18} />}
          onClick={() => navigate('/tutor')}
        >
          开始入学诊断
        </Button>
      </section>

      <div className="dashboard-grid">
        <section className="task-panel" aria-labelledby="today-tasks-heading">
          <div className="section-heading">
            <div>
              <h2 id="today-tasks-heading">今日任务</h2>
              <p>按顺序完成，系统会逐步形成个人学习路径。</p>
            </div>
            <span className="task-progress" aria-label="已完成任务数量">
              {completedTaskIds.size} / {LEARNING_TASKS.length}
            </span>
          </div>

          <div className="task-path">
            {LEARNING_TASKS.map((task, index) => {
              const isComplete = completedTaskIds.has(task.id)
              return (
                <article
                  key={task.id}
                  className={`task-row ${isComplete ? 'task-row--complete' : ''}`}
                >
                  <button
                    type="button"
                    className="task-node"
                    aria-label={`${isComplete ? '取消完成' : '标记完成'}：${task.title}`}
                    onClick={() => toggleTask(task.id)}
                  >
                    {isComplete ? <Check size={17} /> : index + 1}
                  </button>
                  <button
                    type="button"
                    className="task-row__content"
                    onClick={() => navigate(task.targetPath)}
                  >
                    <span className="task-row__copy">
                      <strong>{task.title}</strong>
                      <span>{task.description}</span>
                    </span>
                    <span className="task-row__meta">
                      <span>{task.duration}</span>
                      <StatusLabel status={isComplete ? '已完成' : '待完成'} />
                    </span>
                    <ChevronRight size={19} strokeWidth={1.8} aria-hidden="true" />
                  </button>
                </article>
              )
            })}
          </div>
        </section>

        <aside className="dashboard-rail" aria-label="快速入口">
          <section className="rail-section rail-section--blue" aria-labelledby="ai-rail-heading">
            <div className="rail-section__icon" aria-hidden="true">
              <Bot size={21} strokeWidth={1.7} />
            </div>
            <h2 id="ai-rail-heading">AI导师</h2>
            <p>先告诉我你的思路，我会逐步提示，而不是直接给答案。</p>
            <button type="button" onClick={() => navigate('/tutor')}>
              进入辅导
              <ArrowRight size={17} aria-hidden="true" />
            </button>
          </section>

          <section className="rail-section rail-section--teal" aria-labelledby="materials-rail-heading">
            <div className="rail-section__icon" aria-hidden="true">
              <FileUp size={21} strokeWidth={1.7} />
            </div>
            <h2 id="materials-rail-heading">动态资料库</h2>
            <p>等待上传教材、暑假作业或最近数学试卷。</p>
            <button type="button" onClick={() => navigate('/materials')}>
              上传资料
              <ArrowRight size={17} aria-hidden="true" />
            </button>
          </section>
        </aside>
      </div>

      <section className="knowledge-overview" aria-labelledby="knowledge-overview-heading">
        <div className="section-heading section-heading--map">
          <div>
            <h2 id="knowledge-overview-heading">数学学习地图</h2>
            <p>入学诊断完成后，每个模块会生成掌握证据和下一步任务。</p>
          </div>
          <button type="button" onClick={() => navigate('/learning-map')}>
            查看完整地图
            <ArrowRight size={17} aria-hidden="true" />
          </button>
        </div>

        <div className="knowledge-table" role="table" aria-label="数学学习地图">
          <div className="knowledge-table__header" role="row">
            <span role="columnheader">知识模块</span>
            <span role="columnheader">学习状态</span>
            <span role="columnheader">下一步行动</span>
          </div>
          {KNOWLEDGE_MODULES.map((module) => (
            <button
              key={module.id}
              type="button"
              className="knowledge-table__row"
              role="row"
              onClick={() => navigate('/learning-map')}
            >
              <span role="cell">{module.name}</span>
              <span role="cell">
                <StatusLabel status={module.status} />
              </span>
              <span role="cell">
                {module.action}
                <ChevronRight size={17} aria-hidden="true" />
              </span>
            </button>
          ))}
        </div>

        <button className="parent-report-link" type="button" onClick={() => navigate('/parent')}>
          <span>本周家长报告</span>
          <strong>尚未生成</strong>
          <ChevronRight size={18} aria-hidden="true" />
        </button>
      </section>
    </div>
  )
}
